import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';  
import { RouterModule, Routes } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AllotAuditorComponent } from './allot-auditor.component';



const routes: Routes = [
  {
    path: "",
    data: {
      title: "Allot",
      urls: [{ title: "Allot", url: "/allot" }, { title: "Allot" }],
    },
    component: AllotAuditorComponent,
  },
];
@NgModule({
  declarations: [AllotAuditorComponent],
  imports: [
    CommonModule,
    FormsModule,  
    NgxDatatableModule,
   
    RouterModule.forChild(routes),
  ] 
})
export class AllotAuditorModule{}
